/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatDocIcon16Light } from './FileFormatDocIcon16Light';
import { FileFormatDocIcon16Regular } from './FileFormatDocIcon16Regular';
import { FileFormatDocIcon16Solid } from './FileFormatDocIcon16Solid';
import { FileFormatDocIcon20Light } from './FileFormatDocIcon20Light';
import { FileFormatDocIcon20Regular } from './FileFormatDocIcon20Regular';
import { FileFormatDocIcon20Solid } from './FileFormatDocIcon20Solid';
import { FileFormatDocIcon24Regular } from './FileFormatDocIcon24Regular';
import { FileFormatDocIcon24Solid } from './FileFormatDocIcon24Solid';
import { FileFormatDocIcon32Regular } from './FileFormatDocIcon32Regular';
import { FileFormatDocIcon64Regular } from './FileFormatDocIcon64Regular';
var sizes = {
    16: {
        light: FileFormatDocIcon16Light,
        regular: FileFormatDocIcon16Regular,
        solid: FileFormatDocIcon16Solid,
    },
    20: {
        light: FileFormatDocIcon20Light,
        regular: FileFormatDocIcon20Regular,
        solid: FileFormatDocIcon20Solid,
    },
    24: {
        regular: FileFormatDocIcon24Regular,
        solid: FileFormatDocIcon24Solid,
    },
    32: {
        regular: FileFormatDocIcon32Regular,
    },
    64: {
        regular: FileFormatDocIcon64Regular,
    },
};
export var FileFormatDocIcon = forwardRef('FileFormatDocIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
